import React from 'react';
import { ShareStyle } from './Content.style';
import { Notification } from 'components/CustomNotification';
import { DDItem } from './Home.style';
import { Button } from 'components';
import { t } from 'i18next';

import {
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  FacebookMessengerIcon,
  RedditIcon,
  FacebookShareButton,
  FacebookMessengerShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  RedditShareButton,
  TelegramIcon,
  TelegramShareButton,
} from 'react-share';
import { ShareBaseUrl } from 'environment';

const ShareIconList = (webUrl) => {
  return [
    {
      title: 'Whatsapp',
      icon: (
        <WhatsappShareButton url={webUrl}>
          <WhatsappIcon round={true} />
          <div> Whatsapp</div>
        </WhatsappShareButton>
      ),
    },
    {
      title: 'Facebook',
      icon: (
        <FacebookShareButton url={webUrl}>
          <FacebookIcon round={true} />
          <div>Facebook</div>
        </FacebookShareButton>
      ),
    },
    {
      title: 'Messanger',
      icon: (
        <FacebookMessengerShareButton url={webUrl}>
          <FacebookMessengerIcon round={true} />
          <div>Messanger</div>
        </FacebookMessengerShareButton>
      ),
    },
    {
      title: 'Twitter',
      icon: (
        <TwitterShareButton url={webUrl}>
          <TwitterIcon round={true} />
          <div>Twitter</div>
        </TwitterShareButton>
      ),
    },
    {
      title: 'Reddit',
      icon: (
        <RedditShareButton url={webUrl}>
          <RedditIcon round={true} />
          <div>Reddit</div>
        </RedditShareButton>
      ),
    },
    {
      title: 'Telegram',
      icon: (
        <TelegramShareButton url={webUrl}>
          <TelegramIcon round={true} />
          <div>Telegram</div>
        </TelegramShareButton>
      ),
    },
  ];
};

export default function ShareModal({ path }) {
  const webUrl = `${ShareBaseUrl}${path}`;

  // Web Sharing
  const copy = () => {
    navigator.clipboard.writeText(webUrl);
    Notification('success', 'Copied');
  };

  return (
    <ShareStyle>
      <div className="share-div">
        {ShareIconList(webUrl).map((data, index) => (
          <DDItem key={index} share={true}>
            {data.icon}
          </DDItem>
        ))}
      </div>
      <div className="copy-container">
        <div>
          <div id="copy-text">{webUrl}</div>
        </div>
        <Button variant="text" label={t(`HomePage.Copy`)} onClick={copy} />
      </div>
    </ShareStyle>
  );
}
